import React, { createContext, useContext } from 'react';

import { FEATURES } from './constants';

export interface FeatureFlagContextType {
  addressDetailMaxLength: number;
  addressDetailMinLength: number;
  googleApiKey: string;
  isCASUploadKTPEnabled: boolean;
  isCancelAgeButtonEnabled: boolean;
  isChangePhoneNumberEnabled: boolean;
  isEmailMandatory: boolean;
  isForceSetPackageIdEnabled: boolean;
  isGeoplaceEnable: boolean;
  isGeoplaceRequired: boolean;
  isHideGenderEnabled: boolean;
  isKTPWarningEnabled: boolean;
  isLeadReviveEnabled: boolean;
  isLiveNessEnabled: boolean;
  isMapGeotaggingEnabled: boolean;
  isMapMandatory: boolean;
  isOnboardingServiceEnabled: boolean;
  isRedirectEnabled: boolean;
  isSameAddressRadioVisible: boolean;
  maxAge: number;
  minAge: number;
  minAgeSingle: number;
  minRatingForPositiveFeedback: number;
  spouseMinAge: number;
  isBpkbTaxStnkStatusVisible: boolean;
}

interface FeatureFlagProviderProps {
  children?: React.ReactNode;
}

export const FeatureFlagContext =
  createContext<FeatureFlagContextType>(FEATURES);

FeatureFlagContext.displayName = 'Feature Flags Context';

export const FeatureFlagProvider = ({ children }: FeatureFlagProviderProps) => (
  <FeatureFlagContext.Provider value={FEATURES}>
    {children}
  </FeatureFlagContext.Provider>
);
export const useFeatureFlag = () => useContext(FeatureFlagContext);
